// Side-effect import: must be the first import in index.js so the shim is in
// place before any module reads storage at load time.
import { installStorageShims } from './storageShim';

installStorageShims();
